// extracted by mini-css-extract-plugin
module.exports = {"place":"NotificationContent_place__2Udz9","decisionContent":"NotificationContent_decisionContent__wvdov"};